import { api } from './api.js';

export const reviewService = {
  // Buscar reviews de uma entidade
  getEntityReviews: async (entityId) => {
    try {
      const response = await api.get(`/v1/api/reviews?entityId=${entityId}`);
      
      // A API retorna os dados em response.response
      const reviewsData = response.data?.response || [];
      
      return {
        success: true,
        reviews: Array.isArray(reviewsData) ? reviewsData : []
      };
    } catch (error) {
      console.error('Erro ao buscar reviews:', error);
      return {
        success: false,
        error: error.response?.data?.msg || error.response?.data?.message || 'Erro ao buscar reviews',
        reviews: []
      };
    }
  }
};
